import { render, staticRenderFns } from "./wig-page-general-list.vue?vue&type=template&id=69bdc0bf&scoped=true"
import script from "./wig-page-general-list.vue?vue&type=script&lang=js"
export * from "./wig-page-general-list.vue?vue&type=script&lang=js"
import style0 from "./wig-page-general-list.vue?vue&type=style&index=0&id=69bdc0bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bdc0bf",
  null
  
)

export default component.exports